(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('LegalActualInfoService', LegalActualInfoService);

    LegalActualInfoService.$inject = ['$resource', 'ENV'];

    function LegalActualInfoService($resource, ENV) {

        var fetchInfo = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/v2/company/legal-info';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false},
                    'update': { method: 'PUT'}
                }
            );
        };

        var fetchInfoWithCompanyId = function (company_id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/legal-info/' + company_id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            fetchInfo: fetchInfo,
            fetchInfoWithCompanyId: fetchInfoWithCompanyId
        }

    }
})()